import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const publishRegistry = async ({ profile, items }) => {
  // strip functions / non-serialisable
  const cleanItems = items.map((i) => ({
    id: i.id, title: i.title, tag: i.tag, format: i.format,
    image: i.image, description: i.description,
  }));
  const cleanProfile = {
    dueDate: profile.dueDate ? new Date(profile.dueDate).toISOString() : null,
    priorities: profile.priorities || [],
  };
  const { data } = await axios.post(`${API}/registries`, {
    profile: cleanProfile,
    items: cleanItems,
    origin_url: window.location.origin,
  });
  return data;
};

export const fetchRegistry = async (slug) => {
  const { data } = await axios.get(`${API}/registries/${slug}`);
  return data;
};

export const startCheckout = async ({ slug, amount, giver, message }) => {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    slug, amount, giver, message,
    origin_url: window.location.origin,
  });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
};
